import Form from "@rjsf/core";
import type { RJSFSchema, UiSchema } from "@rjsf/utils";
import { forwardRef, useImperativeHandle, useRef } from "react";
import {
	type JsonObject,
	jsonSchemaDefaultFormStateBehavior,
	normalizeRequiredNullableFields,
} from "src/components/common/forms/jsonSchema/jsonSchemaObjectInputUtils.ts";
import { translateJsonSchemaFormString } from "src/components/common/forms/jsonSchema/jsonSchemaObjectLocalization.ts";
import { jsonSchemaObjectValidator } from "src/components/common/forms/jsonSchema/jsonSchemaObjectValidator.ts";
import {
	aavoJsonSchemaTemplates,
	aavoJsonSchemaWidgets,
} from "src/components/common/forms/jsonSchema/aavoJsonSchemaTheme.ts";

export interface JsonSchemaObjectFormRef {
	validate: () => boolean;
}

export interface JsonSchemaObjectFormProps {
	schema: RJSFSchema;
	uiSchema?: UiSchema;
	formData: JsonObject;
	readOnly?: boolean;
	onChange: (formData: JsonObject, fieldId?: string) => void;
}

export const JsonSchemaObjectForm = forwardRef<JsonSchemaObjectFormRef, JsonSchemaObjectFormProps>(
	function JsonSchemaObjectForm({ schema, uiSchema, formData, readOnly = false, onChange }, ref) {
		const formRef = useRef<Form<JsonObject, RJSFSchema> | null>(null);

		useImperativeHandle(ref, () => ({
			validate: () => formRef.current?.validateForm() === true,
		}));

		return (
			<Form<JsonObject, RJSFSchema>
				ref={formRef}
				schema={schema}
				uiSchema={uiSchema}
				validator={jsonSchemaObjectValidator}
				widgets={aavoJsonSchemaWidgets}
				templates={aavoJsonSchemaTemplates}
				formData={formData}
				experimental_defaultFormStateBehavior={jsonSchemaDefaultFormStateBehavior}
				readonly={readOnly}
				focusOnFirstError
				showErrorList={false}
				translateString={translateJsonSchemaFormString}
				onChange={({ formData }, fieldId) =>
					onChange(normalizeRequiredNullableFields(schema, formData ?? {}), fieldId)
				}
			>
				<></>
			</Form>
		);
	},
);
